import { ClientListItem } from 'src/admin/users/types';
import { CreateFamilyPayload } from '../hooks/useCreateFamily';
import { Family } from '../hooks/useFamily';

export type V2MemberRoles = Record<string, string | null>;

type InProgressFamilyRolesV2 = {
  selectedMembers: ClientListItem[];
  roles: V2MemberRoles;
  name: string;
};

export function isMemberSelected(
  client: ClientListItem,
  selectedMembers: ClientListItem[],
): boolean {
  return selectedMembers.some(m => m.id === client.id);
}

// Builds the full-family PUT payload for adding a single client to an existing
// family, preserving the existing members and their roles.
export function addClientToFamilyPayload(family: Family, newClientId: string): CreateFamilyPayload {
  return {
    name: family.name,
    advisorUserId: family.advisorUserId,
    members: [
      ...family.members.map(m => ({ clientId: m.clientId, familyRoleId: m.familyRoleId })),
      { clientId: newClientId, familyRoleId: null },
    ],
  };
}

export function roleModelPayloadFromInProgressFamilyV2(
  family: InProgressFamilyRolesV2,
  advisorUserId: string,
): CreateFamilyPayload {
  return {
    name: family.name,
    advisorUserId,
    members: family.selectedMembers.map(m => ({
      clientId: m.id,
      familyRoleId: family.roles[m.id] ?? null,
    })),
  };
}
